import { getTranslation } from '@resy/ui-kitchen';
import Logger from '../../../../../ui-kitchen/src/utils/logger';

export const IYP_MODAL_DELAY_MS = 1000;
export const IYP_MODAL_CLOSE_DELAY_MS = 1200;
export const IYP_MODAL_AVATAR_BUTTON_ID = 'iyp-modal-avatar-invite-button';
export const IYP_MODAL_FLAG_KEY = 'iyp-modal-enabled';
export const DATADOG_APPLICATION_ID = '2bbbad6e-67cb-4049-a31e-8384e15fbd90';
export const DATADOG_APPLICATION_NAME = 'resy-web';
export const IYP_SHARE_INVITE_ACTION_NAME = 'iyp share invite';
export const IYP_MODAL_AVATAR_ACTION_NAME = 'iyp share invite - iyp modal avatar';
export const IYP_MODAL_INVITE_ACTION_NAME = 'iyp share invite - iyp modal invite button';
export const IYP_SHARE_INVITE_CTA_CONTEXT = {
  MODAL_AVATAR: 'iyp modal avatar',
  MODAL_INVITE_BUTTON: 'iyp modal invite button',
  NON_MODAL_INVITE_BUTTON: 'iyp accordion avatar',
};
export const IYP_SHARE_INVITE_SURFACE = {
  MODAL: 'iyp modal',
  NON_MODAL: 'iyp accordion',
};

export function checkIsOwnReservation(reservation) {
  return reservation?.attendee?.type === 'host';
}

export function isEligibleForIypModal({
  getPageContext,
  hasShownIypModalInFlow,
  hash,
  inFrameCheck,
  matchMedia,
  pageContexts,
  reservation,
}) {
  if (!reservation) return false;

  const isMobileWeb = !matchMedia?.md;
  const isNotEmbedded = !inFrameCheck();
  const isHost = reservation.attendee?.type === 'host';
  const isPostBooking = getPageContext(hash) === pageContexts.POST_BOOKING;
  const isFutureReservation = reservation.pastOrFuture === 'future';
  const guestCount = reservation.seats || reservation.party?.length || 1;
  const isAtLeastTwoGuests = guestCount >= 2;

  return isMobileWeb
    && isNotEmbedded
    && isHost
    && isPostBooking
    && isFutureReservation
    && isAtLeastTwoGuests
    && !hasShownIypModalInFlow;
}

export function getIypAnalyticsPayload(reservation) {
  return {
    resyToken: reservation?.token,
  };
}

export function getIypModalInviteContext(tapTarget) {
  return tapTarget === 'avatar_plus'
    ? 'Confirmation - IYP Modal Avatar'
    : 'Confirmation - IYP Modal Invite';
}

export function isIypModalInviteContext(context) {
  return context === 'Confirmation - IYP Modal Avatar'
    || context === 'Confirmation - IYP Modal Invite';
}

export function getIypDismissalMethod(event) {
  return event?.type === 'keydown' ? 'esc' : 'overlay';
}

export async function copyInviteLinkWithShareSheet({
  matchMedia,
  reservation,
}) {
  if (!checkIsOwnReservation(reservation)) {
    return { didCopy: false, method: 'none' };
  }

  if (!matchMedia.md) {
    const dateTime = reservation.dateTime || moment(`${reservation.day} ${reservation.time}`, 'YYYY-MM-DD HH:mm:ss').format('llll');
    const [reservationDate, reservationTime] = dateTime.split(/, \d{4} /);
    const venueName = reservation.venue?.name;
    const shareDetails = {
      url: reservation.share?.link,
      title: getTranslation({
        translationKey: 'reservation_sheet_title',
        translationValues: { venueName },
        fallback: `RSVP at ${venueName}`,
      }),
      text: getTranslation({
        translationKey: 'reservation_sheet_sms_message',
        translationValues: {
          venueName,
          reservationDate,
          reservationTime,
        },
        fallback: `Join my reservation for ${venueName} for ${reservationDate} at ${reservationTime}`,
      }),
    };
    // eslint-disable-next-line no-undef
    if (navigator.share && navigator.canShare(shareDetails)) {
      try {
        // eslint-disable-next-line no-undef
        await navigator.share(shareDetails);
        return { didCopy: true, method: 'share' };
      } catch (err) {
        if (err?.name === 'AbortError') {
          return { didCopy: true, method: 'share' };
        }
        Logger.error(`[GuestInvite] Error bringing up share menu: ${err}`);
      }
    }
  }

  try {
    // eslint-disable-next-line no-undef
    await navigator.clipboard.writeText(reservation.share?.link);
    return { didCopy: true, method: 'clipboard' };
  } catch (error) {
    Logger.error(`[GuestInvite] error copying reservation link to clipboard: ${error}`);
  }

  return { didCopy: false, method: 'none' };
}
